import { ExtendedRawUserProfile } from 'hooks/useIdentifyAnalytics/types';
import { PianoUser } from 'types/piano';

import type { HeaderUserData, FooterUserData } from './types';
import { headerProfileFactory, footerProfileFactory } from './profileFactory';

/**
 * Implementation based on
 * https://github.com/pocketoutdoormedia/activity-feed/blob/56b4a3cf872874d7281a919d6e8f15eee64ec627/src/components/03-organism/header/utils/mappers.ts
 */
export const headerProfileMapFactory = (
  RIVTProfile: ExtendedRawUserProfile
): HeaderUserData['profileMap'] => {
  const profile = headerProfileFactory(RIVTProfile);

  // Map to key-value Iterable for Map constructor
  return new Map([[profile.uuid, profile]]);
};

export const footerProfileMapFactory = (
  RIVTProfile: ExtendedRawUserProfile,
  pianoUser: PianoUser
): FooterUserData['profileMap'] => {
  const profile = footerProfileFactory(RIVTProfile, pianoUser);

  // Map to key-value Iterable for Map constructor
  return new Map([[profile.uuid, profile]]);
};
